import './src/styles/global.css'
import '@webiny/react-rich-text-renderer/styles.scss';


import { Amplify } from 'aws-amplify';
import awsconfig from './src/aws-exports';
Amplify.configure(awsconfig);
